<template>
    <div id="home" class="home-page">
        <banners />
        <games />
        <solutions />
        <about />
        <contacts />
    </div>
</template>

<script>
    import Banners from '../components/banners.vue'
    import Games from '../components/games.vue'
    import Solutions from '../components/solutions.vue'
    import About from '../components/about.vue'
    import Contacts from '../components/contacts.vue'

    export default {
        name: 'HomePage',
        components: { Banners, Games, Solutions, About, Contacts }
    }
</script>

<style lang="scss" scoped>
    .home-page {
        flex: 1 1 auto;

        .banners {
            height: 100vh;
            padding-top: $main-top;
            margin-top: -$main-top;
        }

        @media (max-width: ($desktop)-1) {
            .banners {
                padding-top: $main-top-mobile;
                margin-top: -$main-top-mobile;
            }
        }
    }
</style>
